export default __webpack_public_path__ + "static/media/top-arrow.8d010222.svg";